require("./src/static/style.css")
